module.exports = __webpack_public_path__ + "static/media/JW-marriot01.a2e48c84.jpg";